/**
 *  @class
 *  @function MultiRow
 */
if (!customElements.get('multi-row')) {
  class MultiRow extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.container = this.querySelector('.multi-row--inner');
      this.rows = Array.from(this.querySelectorAll('.multi-row--row'));
      this.spacer = 100;
      this.tl = gsap.timeline();

      this._scrollTriggers = [];
      this._onResize = () => this.initCards();
      this._onRefresh = this.initCards.bind(this);

      this.initCards();
      this.setupScroll();
      window.addEventListener('resize', this._onResize);
      document.fonts.ready.then(this._onResize);
    }
    initCards() {
      this.totalOffset = 0;
      this.totalHeight = 0;
      let property = gsap.getProperty('html', '--header-height');

      this.rows.forEach((row, index) => {

        if (index > 0) {
          this.totalOffset += row.querySelector('.multi-row--content-heading').offsetHeight;
          row.dataset.offset = this.totalOffset;
        } else {
          this.totalOffset = 0 + property;
          row.dataset.offset = this.totalOffset;
        }
        this.totalHeight += row.offsetHeight;
      });

      gsap.set(this.container, { minHeight: this.totalHeight + this.totalOffset + ((this.rows.length - 1) * property) });
    }
    setupScroll() {

      let getOffset = (row) => {
        return row.dataset.offset;
      };
      this.rows.forEach((row, index) => {
        this._scrollTriggers.push(ScrollTrigger.create({
          trigger: row,
          start: `top top+=${getOffset(row)}`,
          endTrigger: this.container,
          end: `bottom bottom`,
          pinnedContainer: this.container,
          pin: true,
          scrub: true,
          pinSpacing: false,
          anticipatePin: 1,
          fastScrollEnd: true,
          invalidateOnRefresh: true,
          //markers: true,
          id: "card-" + index
        }));
      });
      ScrollTrigger.addEventListener('refreshInit', this._onRefresh);
    }
    disconnectedCallback() {
      this._scrollTriggers.forEach(st => st.kill());
      this._scrollTriggers = [];
      window.removeEventListener('resize', this._onResize);
      ScrollTrigger.removeEventListener('refreshInit', this._onRefresh);
    }
  }
  customElements.define('multi-row', MultiRow);
}